import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EditPage, EditPagePanel, EditPageTextField, EditPageSelect, EditPageCheckbox } from './../../../../common/EditPage';
import { useParams, useNavigate } from 'react-router-dom';
import { getOne, create } from './../../../../common/v4/BackendProvider';
import { toast } from 'react-toastify';

const ClientAccountNumbersCreate = () => {
    const [metadata, setMetadata] = useState({});
    const [data, setData] = useState({status: true});
    const { account_id } = useParams();
    const navigate = useNavigate();
    useEffect(() => {
        getOne(`/admin/clients/clients/${account_id}/numbers/`, 'new').then(response => {
            setMetadata(response.data.metadata);
        }).catch(error => {
            toast.error("Error fetching numbers: " + error.message, {});
        });
    }, [account_id]);

    const handleSave = () => {
        create(`/admin/clients/clients/${account_id}/numbers/`, {data: data}).then(() => {
            navigate(`/clients/clients/${account_id}/numbers`);
        }).catch(error => {
            toast.error("Error creating number: " + error.message, {});
        });
    };

    const handleCancel = () => {
        console.log('cancel');
        navigate(`/clients/clients/${account_id}/numbers`);
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } >
                <EditPagePanel>
                    <EditPageSelect label="Number" id="number" onChange={ onChange } value={ data.number } options={ metadata?.numbers?.values } />
                    <EditPageSelect label="SMPP Account" id="smpp_account_id" onChange={ onChange } value={ data.smpp_account_id } options={ metadata?.smpp_account_id?.values } nullable={ true } />
                    <EditPageCheckbox label="Enabled" id="status" onChange={ onChange } value={ data.status } />
                </EditPagePanel>
            </EditPage>
        </>
    )
}   

export default ClientAccountNumbersCreate;